module.exports = __webpack_public_path__ + "static/Sailec_Bold-4e35ad5a46230bc58c41b76ce0753892.woff";